exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".actionsheet-overlay {\n  background-color: rgba(0,0,0,0);\n  position: fixed;\n  z-index: 998;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  transition: all 300ms ease-out;\n}\n.actionsheet-overlay.active{\n  background-color: rgba(0,0,0,0.2);\n}\n.actionsheet {\n  position: absolute;\n  font-family:\"Helvetica Neue\", Helvetica,sans-serif;\n  left: 2px;\n  right: 2px;\n  bottom: 0px;\n  z-index: 999;\n  transform: translateY(110%);\n  transition: all 300ms ease-out;\n}\n.actionsheet-overlay.active .actionsheet{\n  transform: translateY(0);\n}\n.actionsheet-item {\n  color: #000;\n  line-height: 2.5;\n  font-size: 18px;\n  background-color: rgba(255,255,255,0.8);\n  text-align: center;\n  user-select: none;\n  -webkit-user-select: none;\n}\n.actionsheet-item:active,\n.actionsheet-item:hover {\n  background-color: rgba(255,255,255,0.3);\n}\n.actionsheet-foot {\n  margin-top: 4px;\n}\n.actionsheet-item + .actionsheet-item {\n  border-top: 1px solid rgba(0,0,0,0.2);\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./style.css
 ** module id = 10
 ** module chunks = 0
 **/